"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'PFA_Hero_1_0_0',
  headingLarge: 'Adventure Meets Style',
  headingSmall: '2026 OUTLANDER from $28,395',
  logoURL: '/content/dam/mitsubishi-motors-us/images/logos/iron_man.jpeg',
  description: '',
  imageSize: 'large',
  mksTagId: 'pfahero',
  backgroundImage: {
    altText: 'Pink flower',
    image: 'http://localhost:4502/content/dam/mitsubishi-motors-us/images/icons/flower.jpeg'
  },
  mobileImage: {
    altText: 'Pink flower',
    image: 'http://localhost:4502/content/dam/mitsubishi-motors-us/images/logos/iron_man.jpeg'
  },
  textBlockAlignment: null,
  ctas: [{
    label: 'Build & Price',
    link: '/en/configure-your-mitsubishi/configurator',
    linkOriginal: '/content/mitsubishi-motors/us/en/configure-your-mitsubishi/configurator',
    selectActionType: null,
    openNewTab: true,
    backgroundCTA: 'red'
  }, {
    label: 'Book a Test Drive',
    link: '/en/test-drive',
    linkOriginal: '/content/mitsubishi-motors/us/en/test-drive',
    selectActionType: null,
    openNewTab: false,
    backgroundCTA: 'white'
  }]
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;